import type {
  FieldGlobalAttributes,
  FormattingOperator,
} from '@ardoq/api-types';
import { ARDOQ_DEFAULT_LOCALE } from '@ardoq/locale';
import { getCustomFieldsFormattingGroupIfAnyFieldIsAvailableOrNull } from './composeFormattingGroups/getCustomFieldsFormattingGroup';
import { augmentFormattingComparators } from './mapFormattingRuleInfo';
import { type BuiltInFieldDef, toBuiltInFieldFormatting } from './utils';

/**
 * The comparators the conditional-formatting panel offers for each custom
 * field, by field name. Includes the combined date-range fields the panel
 * offers for a start and end field.
 */
export const getFormattingComparatorsByFieldName = (
  fields: FieldGlobalAttributes[]
): Record<string, FormattingOperator[]> =>
  Object.fromEntries(
    (
      getCustomFieldsFormattingGroupIfAnyFieldIsAvailableOrNull(
        fields,
        true,
        ARDOQ_DEFAULT_LOCALE
      )?.filters ?? []
    ).map(formatting => [
      formatting.id,
      augmentFormattingComparators(true, formatting).flat(),
    ])
  );

/** The comparators the conditional-formatting panel offers for a built-in field. */
export const getFormattingComparatorsForBuiltInField = (
  def: BuiltInFieldDef
): FormattingOperator[] =>
  augmentFormattingComparators(
    true,
    toBuiltInFieldFormatting(def, def.id, [])
  ).flat();
